import { render, staticRenderFns } from "./CatalogDetails.vue?vue&type=template&id=1af21d79&scoped=true"
import script from "./CatalogDetails.vue?vue&type=script&lang=js"
export * from "./CatalogDetails.vue?vue&type=script&lang=js"
import style0 from "./CatalogDetails.vue?vue&type=style&index=0&id=1af21d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af21d79",
  null
  
)

export default component.exports